import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
import fonts from '../utils/fonts';

// COLOR LINEAS

const filetes = colors.oscuro;

const Contenedor = styled.div`
  margin: 0 auto;
  margin-top: 1em;
  text-align: left;
  margin-bottom: 6rem;
`;
const Subtituloh4 = styled.h5`
  color: ${colors.oscuro};
  font-family: ${fonts.sans}, sans-serif;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0.02em;
  background-image: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 37px, ${filetes} 37px, ${filetes} 38px);
  background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0) 37px, ${filetes} 37px, ${filetes} 38px);
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 37px, ${filetes} 37px, ${filetes} 38px);
  background-repeat: repeat-y;
  background-size: 100% 38px;
  &:before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-bottom: 3px;
    border-radius: 50%;
    background: ${colors.main};
    vertical-align: middle;
    margin-right: 7px;
  }
  @media (max-width: 768px) {
    line-height: 34px;
    letter-spacing: 0.02em;
    background-image: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 37px, ${filetes} 33px, ${filetes} 34px);
    background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0) 33px, ${filetes} 33px, ${filetes} 34px);
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 33px, ${filetes} 33px, ${filetes} 34px);
    background-repeat: repeat-y;
    background-size: 100% 34px;
  }
`;

const SubtituloFilete = ({ contenido }) => (
  <Contenedor>
    <Subtituloh4>{contenido}</Subtituloh4>
  </Contenedor>
);

export default SubtituloFilete;



// WEBPACK FOOTER //
// ./src/components/SubtituloFilete.js